import { render, staticRenderFns } from "./SideNavigationQuickMenu.vue?vue&type=template&id=ed659422&"
import script from "./SideNavigationQuickMenu.vue?vue&type=script&lang=ts&"
export * from "./SideNavigationQuickMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed659422')) {
      api.createRecord('ed659422', component.options)
    } else {
      api.reload('ed659422', component.options)
    }
    module.hot.accept("./SideNavigationQuickMenu.vue?vue&type=template&id=ed659422&", function () {
      api.rerender('ed659422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/navigation/side/SideNavigationQuickMenu.vue"
export default component.exports